<template>
  <sdPageHeader class="header-boxed" :title="$t('pages.statistics.title')"> 
<template v-slot:buttons>
      <div class="page-header-actions">
        <a-radio-group @change="forcastOverview" v-model:value="selectedDate">
          <a-radio-button value="today">{{$t("common.today")}}</a-radio-button>
          <a-radio-button value="week">{{$t("common.week")}}</a-radio-button>
          <a-radio-button value="month">{{$t("common.month")}}</a-radio-button>
          <a-radio-button value="year">{{$t("common.year")}}</a-radio-button>
          <a-radio-button value="all">{{$t("common.view-all")}}</a-radio-button>
        </a-radio-group>
      </div>
    </template>

  </sdPageHeader>
  <Main class="grid-boxed">
    <a-radio-group @change="onTabChange" v-model:value="activeKey" button-style="solid">
        <a-radio-button value="statistics-developer">{{$t("pages.statistics.developer")}}</a-radio-button>
        <a-radio-button value="statistics-app">{{$t("pages.statistics.app")}}</a-radio-button>
        <a-radio-button value="statistics-sale">{{$t("pages.statistics.sale")}}</a-radio-button>
        <a-radio-button value="statistics-customer">{{$t("pages.statistics.customer")}}</a-radio-button>
      </a-radio-group>
      
      <router-view />

  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { mapGetters } from 'vuex';


export default {
  components: {
    Main,
  },
  data() {
    return {
      activeKey: this.$route.name,
    };
  },
  methods: {
    onTabChange(e) {
      this.$router.push({ name: e.target.value });
    },
    forcastOverview(e) {
      this.$store.dispatch('statistics/setDateInfo', e.target.value);
    }
  },
  computed: {
    ...mapGetters({
      date_info: 'statistics/get_date_info'
    }),
    selectedDate: {
      get () {
        return this.date_info;
      },
      set(item) {
        // this.$store.dispatch('statistics/setDateInfo', item);
      }
    }
  }
};
</script>
